import React, { useState, useEffect } from "react";
import {
  Save,
  Building2,
  X,
  FileText,
  ChevronDown,
  ChevronUp,
  Check,
  Shield,
  CreditCard,
  Truck,
  Ship,
  Plane,
  Package,
  Users,
  AlertCircle,
  CheckCircle2,
} from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { Input } from "../ui/input";
import { SearchBar } from "../SearchBox/SearchBar";

import {
  getAddressByID,
  DeleteCompanyAddress,
  createAddressBook,
  UpdateAddressBook,
  createAddressBookAddress,
  UpdateAddressBookAddress,
  getCPPositionList,
  getSelectedAccountAddress,
  DocUpdatebyAddressbook,
  InsertComplianceCertification,
  GetComplianceCertificationByID,
  GetCompanyAddressAdditionalDetails,
  UpdateCompanyAddressAdditionalDetails,
  getCheckDuplicateCompanyist,
  CreateUpdateCarrierContracts,
  getCarrierContractsByCompanyid
} from "@/redux/Address/actions";

import { toast } from "sonner";
import { motion } from "framer-motion";
import { validateForm } from "../ui/useFormValidation";
import { callLoader } from "@/redux/Loader/actions";
import AddressBookAccount from "./AddressBookAccount";
import { showToast } from "@/redux/Toast/actions";
import CelebrationButton from "../ui/CelebrationButton/CelebrationButton";
import ModeConfigTab from "./ModeConfigTab";
import {
  addressMap,
  companyMap,
  entityType,
  generateAddressPayload,
  generateCompanyPayload,
  initialaddress,
  initialComplianceData,
  initialFormData,
  initialModeData,
  setComplianceData_,
  validationConfig,
} from "./helper";
import ModesOfTransportation from "./ModesOfTransportation";
import CustomerDetailsSection from "./CustomerDetailsSection";
import AddressDetailsSection from "./AddressDetailsSection";
import PccDocumentationSection from "./PccDocumentationSection";
import AddressListSection from "./AddressListSection";
import ComplianceCertificationSection from "./ComplianceCertificationSection";
import SectionHeader from "./SectionHeader";

// const AddressForm = ({ onBack, bookingData = null }) => {
const AddressForm = ({ onBack, bookingData: initialBookingData = null }) => {
  const [bookingData, setBookingData] = useState(initialBookingData);
  const dispatch = useDispatch();
  const { countryList, salesPersonList, standardTermsList } = useSelector(
    (state) => state.common,
  );
  const { isAnimate } = useSelector((state) => state.toast);
  const [showBox, setShowBox] = useState(false);
  const [dateErrors, setDateErrors] = useState({});
  const authUser = JSON.parse(localStorage.getItem("authUser"))?.[0];
  const user = authUser?.[0];
  const [isEditMode, setIsEditMode] = useState(false);
  const [curriercontractcompanyid, setCurriercontractcompanyid] = useState(0)

  const salesOptions = salesPersonList?.map((s) => ({
    value: s.salesPersonId,
    label: s.salesPerson,
  }));
  const [formData, setFormData] = useState({ ...initialFormData });

  // Mode-specific configuration data for each transportation mode
  const [modeConfigData, setModeConfigData] = useState({
    OCEAN_IMPORT: { ...initialModeData },
    OCEAN_EXPORT: { ...initialModeData },
    AIR_IMPORT: { ...initialModeData },
    AIR_EXPORT: { ...initialModeData },
    DOMESTIC_TOWING: { ...initialModeData },
    WAREHOUSING: { ...initialModeData },
    DISTRIBUTION: { ...initialModeData },
  });

  // Handler to update mode-specific data
  const handleModeDataChange = (modeId, field, value, label) => {
    console.log("field, value,label", field, value, label);
    if (field === "paymentTermsId") {
      setModeConfigData((prev) => ({
        ...prev,
        [modeId]: {
          ...prev[modeId],
          [field]: value,
          paymentTerms: label,
        },
      }));
    } else if (field === "accessControlsBookingApprovalRequiredId") {
      setModeConfigData((prev) => ({
        ...prev,
        [modeId]: {
          ...prev[modeId],
          [field]: value,
          accessControlsBookingApprovalRequired: label,
        },
      }));
    } else if (field === "accessControlsCreditOverrideApprovalId") {
      setModeConfigData((prev) => ({
        ...prev,
        [modeId]: {
          ...prev[modeId],
          [field]: value,
          accessControlsCreditOverrideApproval: label,
        },
      }));
    } else {
      setModeConfigData((prev) => ({
        ...prev,
        [modeId]: {
          ...prev[modeId],
          [field]: value,
        },
      }));
    }
  };

  const [Addresses, setAddresses] = useState([]);
  useEffect(() => {
    if (bookingData != 0 && bookingData != null) {
      console.log("address book:", bookingData);
      _getAddressBook();
      setIsEditMode(true);
    }
    _getdataCpPositionList();
    // else {
    //     _setNewAddressBook();
    // }
  }, [bookingData]);


  const loadCarrierContracts = async (companyId) => {
    try {
      const res = await dispatch(getCarrierContractsByCompanyid(companyId));


      const contracts = res.map(item => item.contractNumber);

      setCarrierList(contracts);

    } catch (error) {
      console.error("Error loading contracts:", error);
    }
  };

  const _getAddressBook = async () => {
    try {

      dispatch(callLoader(1));
      const resultData = await dispatch(getAddressByID(bookingData));

      // try {
      //   const data = await getCPPositionList(); // API call
      //   // console.log("CP Position List Data:", data);
      //   if (Array.isArray(data.data)) {
      //     setCpPositionList(data.data);
      //   } else {
      //     setCpPositionList([]);
      //   }
      // } catch (error) {
      //   setCpPositionList([]);
      // }
      // setFormData(resultData);
      const api = resultData?.payload || resultData; // 👈 VERY IMPORTANT
      console.log("api data:", api);
      const companyId = api?._Company?.id;

      setCurriercontractcompanyid(companyId);
      // ✅ LOAD CONTRACTS HERE (IMPORTANT FIX)
      if (companyId > 0) {
        loadCarrierContracts(companyId);
      }




      setFormData((prev) => {
        const updated = { ...prev };

        Object.keys(companyMap).forEach((key) => {
          updated[key] = api?._Company?.[companyMap[key]] ?? "";
        });

        // Set multi-select salespersons
        // updated.ddlsalesperson = api.salespersonids || [];   // If Array return

        updated.ddlsalesperson = api?._Company?.salespersonids
          ? api?._Company?.salespersonids.split(",").map(Number)
          : []; // if Comma saperated return

        //     Object.keys(addressMap).forEach(key => {
        //     updated[key] = api?.companyAddress?.[addressMap[key]] ?? '';
        //    });



        const currentAddress = Array.isArray(api?.companyAddress)
          ? api.companyAddress[0]
          : api?.companyAddress;
        Object.keys(addressMap).forEach((key) => {
          updated[key] = currentAddress?.[addressMap[key]] ?? "";
        });

        return updated;
      });
      setAddresses(
        Array.isArray(api?.companyAddress)
          ? api.companyAddress
          : api?.companyAddress
            ? [api.companyAddress]
            : [],
      );
    } catch (error) {
    } finally {
      dispatch(callLoader(0));
    }
  };

  const _getdataCpPositionList = async () => {
    try {

      dispatch(callLoader(1));


      try {
        const data = await getCPPositionList(); // API call
        // console.log("CP Position List Data:", data);
        if (Array.isArray(data.data)) {
          setCpPositionList(data.data);
        } else {
          setCpPositionList([]);
        }
      } catch (error) {
        setCpPositionList([]);
      }

    } catch (error) {
    } finally {
      dispatch(callLoader(0));
    }
  };

  const _setNewAddressBook = async () => {
    setFormData();
  };

  const [errors, setErrors] = useState({});

  const [items, setItems] = useState([]);
  const [expandedSections, setExpandedSections] = useState({
    s1: true,
    s1b: true,
    s2: true,
    s3: true,
    s4: false,
    s5: true,
  });

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
      // 👇 auto-fill logic
      ...(name === "companyname" && {
        companyname2: value,
      }),
    }));
  };

  const validateForm_N = () => {
    const newErrors = {};

    // if (!formData.edicode.trim()) {
    //   newErrors.edicode = "EDI Code is required";
    // }
    if (!formData.ddlofficetype) {
      newErrors.ddlofficetype = "Office Type is required";
    }
    if (!formData.companyname.trim()) {
      newErrors.companyname = "Company Name is required";
    }
    if (!formData.ddlsalesperson) {
      newErrors.ddlsalesperson = "Sales Person is required";
    }
    if (!formData.companyname2.trim()) {
      newErrors.companyname2 = "Company Name is required";
    }
    if (!formData.address1.trim()) {
      newErrors.compaaddress1nyname = "Address is required";
    }
    if (!formData.country.trim()) {
      newErrors.country = "Country is required";
    }
    if (!formData.postalcode.trim()) {
      newErrors.postalcode = "Postal Code is required";
    }
    if (!formData.city.trim()) {
      newErrors.city = "City is required";
    }
    if (!formData.state.trim()) {
      newErrors.state = "State is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {

    console.log("Form Data:", formData, "Items:", items);
    if (!isAnyChecked) {
      dispatch(showToast("Please select at least one Entity type", "error"));

      return;
    }

    //    if (!validateForm()) {
    //     return;
    //   }

    const finalPayload = {
      _Company: generateCompanyPayload(
        bookingData,
        authUser,
        salesPersonList,
        formData,
      ),
      Company_Address: generateAddressPayload(bookingData, authUser, formData),
    };




    // formvalidation setting here
    const validationErrors = validateForm({
      data: formData,
      items,
      rules: validationConfig,
    });
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      return;
    }

    try {
      dispatch(callLoader(1));
      if (bookingData != 0 && bookingData != null) {
        const updateDetails = await UpdateAddressBook(finalPayload);
        if (
          updateDetails?.statuscode === 200 ||
          updateDetails?.statuscode === 201
        ) {
          //alert("Update successfully");

          dispatch(showToast("Record Update successfully", "success", true));
        }
      } else {
        const addDetails = await createAddressBook(finalPayload);
        if (addDetails?.statuscode === 201 || addDetails?.statuscode === 200) {
          setBookingData(addDetails?.addressBookId);

          dispatch(showToast("Record Save successfully", "success", true));
        }
      }
      // onBack();

      // ✅ NOW SEND CONTRACTS
      if (carrierList.length > 0 && finalPayload._Company.id > 0) {
        const payloadCurriercontract = {
          companyID: finalPayload._Company.id,
          loggedinUser: authUser.username,
          contracts: carrierList.map(item => ({
            contractNumber: item
          }))
        };

        console.log("payloadCurriercontract" + payloadCurriercontract)

        await CreateUpdateCarrierContracts(payloadCurriercontract);
      }
    } catch (error) {
      dispatch(
        showToast(
          bookingData?.id
            ? "Failed to update company address."
            : "Failed to add company address.",
          "error"
        )
      );
    } finally {
      dispatch(callLoader(0));
    }
  };

  const addItem = (key) => {
    const { id, input, list = [] } = formData[key];
    if (!id) return;

    if (list.some((item) => item.id === id)) return;

    setFormData((prev) => ({
      ...prev,
      [key]: {
        input: "",
        id: "",
        list: [...list, { id, name: input }],
      },
    }));
  };

  const removeItem = (key, id) => {
    setFormData((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        list: prev[key].list.filter((i) => i.id !== id),
      },
    }));
  };

  console.log("formData", formData);

  const SelectedList = ({ title, items = [], onRemove }) => {
    if (!items.length) return null;

    return (
      <div className="mt-4 border border-slate-300 dark:border-slate-700 rounded-lg p-3">
        <h4 className="text-xs font-semibold text-slate-700 dark:text-slate-300 mb-2">
          {title}
        </h4>

        <div className="flex flex-wrap gap-2">
          {items.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-2 px-3 py-1 text-sm bg-slate-100 dark:bg-slate-700 rounded-full"
            >
              <span>{item.name}</span>
              <button
                type="button"
                onClick={() => onRemove(item.id)}
                className="text-red-500 hover:text-red-700"
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      </div>
    );
  };
  const { addressList, pagination } = useSelector((state) => state.addressBook);

  const MultiSearchAdd = ({
    label,
    valueKey,
    searchAPI,
    formData,
    setFormData,
  }) => {
    //   const data = formData[valueKey];
    const data = formData[valueKey] || { input: "", id: "", list: [] };

    return (
      <div>
        <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
          {label}:
        </label>

        <div className="mt-4 border border-slate-300 dark:border-slate-700 rounded-lg p-3">
          <div className="flex items-stretch gap-2">
            {/* SearchBar takes full remaining width */}
            <div className="flex-1">
              <SearchBar
                searchAPI={searchAPI}
                value={data.input}
                selectReacord={(d) => {
                  setFormData((prev) => ({
                    ...prev,
                    [valueKey]: {
                      ...prev[valueKey],
                      input: d?.[1],
                      id: d?.[0],
                    },
                  }));
                }}
              />
            </div>

            {/* Button keeps its natural size */}
            <button
              type="button"
              onClick={() => addItem(valueKey)}
              className="px-3 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              +
            </button>
          </div>
        </div>

        <SelectedList
          title={`Selected ${label}`}
          items={data?.list || []}
          onRemove={(id) => removeItem(valueKey, id)}
        />

        {/* {data.list.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-2">
          {data.list.map(item => (
            <div
              key={item.id}
              className="flex items-center gap-2 px-3 py-1 text-sm bg-slate-100 dark:bg-slate-700 rounded-full"
            >
              <span>{item.name}</span>
              <button
                type="button"
                onClick={() => removeItem(valueKey, item.id)}
                className="text-red-500 hover:text-red-700"
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      )} */}
      </div>
    );
  };

  const handleDateChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value, // YYYY-MM-DD
    }));
  };

  const isAnyChecked = Object.entries(formData)
    .filter(([key]) => key.startsWith("chk"))
    .some(([, value]) => value === true);
  const handleSubmitAddress = async (e) => {

    console.log("Form Data:", formData, "Items:", items);

    if (!isAnyChecked) {
      toast.error("Please select at least one Entity type");
      return;
    }

    // formvalidation setting here
    const validationErrors = validateForm({
      data: formData,
      items,
      rules: validationConfig,
    });
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      return;
    }
    const isEdit = Boolean(bookingData && formData.addressIdSelected);

    // if (bookingData != 0 && bookingData != null && addressId !=0 && addressId != null)
    if (isEdit) {
      const addressPayload = generateAddressPayload(
        bookingData,
        authUser,
        formData,
      );
      const finalPayload = {
        _Company: generateCompanyPayload(
          bookingData,
          authUser,
          salesPersonList,
          formData,
        ),
        // Company_Address: addressPayload
        Company_Address: {
          ...addressPayload,
          addressid: formData.addressIdSelected,
        },
      };




      dispatch(callLoader(1));
      const updateDetailsAddress = await UpdateAddressBookAddress(finalPayload);
      dispatch(callLoader(0));
      if (
        updateDetailsAddress?.statuscode === 200 ||
        updateDetailsAddress?.statuscode === 201
      ) {
        //alert("Update successfully");
        // bookingData=updateDetails?.addressBookId ;
        toast.success("Address Update successfully");
        _getAddressBook();
      } else {
        toast.error("Address update failed. Please try again.");
      }
    } else {
      const addressPayload = generateAddressPayload(
        bookingData,
        authUser,
        formData,
      );
      const finalPayload = {
        // _Company: companyPayload,
        //  Company_Address: addressPayload
        ...addressPayload,
      };



      const addDetailsAddress = await createAddressBookAddress(finalPayload);
      if (
        addDetailsAddress?.statuscode === 200 ||
        addDetailsAddress?.statuscode === 201
      ) {
        toast.success("Address Save successfully");
        _getAddressBook();
      }
    }
    // onBack();
  };
  const handleDateError = (fieldName, hasError) => {
    setDateErrors((prev) => ({
      ...prev,
      [fieldName]: hasError,
    }));
  };
  const handleAddressSelect = (addressId) => {
    const selectedAddress = Addresses.find(
      (addr) => addr.addressid === addressId,
    );

    if (!selectedAddress) return;

    setFormData((prev) => ({
      ...prev,
      addressIdSelected: addressId, // ✅ THIS WAS MISSING
    }));

    // now you have full address data
    fillAddressForm(selectedAddress);
  };
  const fillAddressForm = (address) => {
    setFormData((prev) => {
      const updated = { ...prev };

      Object.keys(addressMap).forEach((key) => {
        updated[key] = address?.[addressMap[key]] ?? "";
      });

      return updated;
    });
  };
  const ResetAddressDetail = () => {
    setFormData((prev) => ({
      ...prev,
      ...initialaddress,
      companyname2: formData.companyname,
    }));

    // Optional: clear validation errors
    setErrors({});
  };
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;
    const updateDetails = await DeleteCompanyAddress(id);
    if (
      updateDetails?.statuscode === 201 ||
      updateDetails?.statuscode === 200
    ) {
      toast.success("Address delete successfully");
      _getAddressBook();
    }
  };

  // Multiple carrier Cont
  const [carrierInput, setCarrierInput] = useState("");
  const [carrierContracts, setCarrierContracts] = useState([]);

  const addCarrierContract = () => {
    if (!carrierInput.trim()) return;

    // prevent duplicate
    if (carrierContracts.includes(carrierInput.trim())) return;

    setCarrierContracts((prev) => [...prev, carrierInput.trim()]);
    setCarrierInput("");
  };

  const removeCarrierContract = (value) => {
    setCarrierContracts((prev) => prev.filter((item) => item !== value));
  };

  const [cpPositionList, setCpPositionList] = useState([]);
  const [selectAccountaddres, setselectAccountaddres] = useState([]);

  // Generate dynamic tabs based on selected modes
  function getModeTabs() {
    const modeTabs = [];
    if (formData?.OCEAN_IMPORT)
      modeTabs.push({
        id: "OCEAN_IMPORT",
        label: "Ocean Import",
        icon: Ship,
        color: "text-blue-500",
      });
    if (formData?.OCEAN_EXPORT)
      modeTabs.push({
        id: "OCEAN_EXPORT",
        label: "Ocean Export",
        icon: Ship,
        color: "text-blue-600",
      });
    if (formData?.AIR_IMPORT)
      modeTabs.push({
        id: "AIR_IMPORT",
        label: "Air Import",
        icon: Plane,
        color: "text-purple-500",
      });
    if (formData?.AIR_EXPORT)
      modeTabs.push({
        id: "AIR_EXPORT",
        label: "Air Export",
        icon: Plane,
        color: "text-purple-600",
      });
    if (formData?.DOMESTIC_TOWING)
      modeTabs.push({
        id: "DOMESTIC_TOWING",
        label: "Domestic/Trucking",
        icon: Truck,
        color: "text-amber-500",
      });
    if (formData?.WAREHOUSING)
      modeTabs.push({
        id: "WAREHOUSING",
        label: "Warehousing",
        icon: Package,
        color: "text-emerald-500",
      });
    if (formData?.DISTRIBUTION)
      modeTabs.push({
        id: "DISTRIBUTION",
        label: "Distribution",
        icon: Users,
        color: "text-rose-500",
      });
    return modeTabs;
  }

  const modeTabs = getModeTabs();

  const tabs = [
    {
      id: "company",
      label: "Company Info",
      icon: Building2,
      alwaysEnabled: true,
    },
    { id: "documentation", label: "Docs/Special Notes", icon: FileText },
    { id: "compliance", label: "Compliance/Certification", icon: Shield },
    { id: "accounting", label: "Accounting", icon: CreditCard },
    ...modeTabs,
  ];
  const [activeTab, setActiveTab] = useState("company");

  const inputClass =
    "w-full px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-sm text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all";
  const selectClass =
    "w-full px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-sm text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all appearance-none cursor-pointer";

  //    const RefreshPrintAddress = () => {
  //   setFormData(prev => ({
  //    ...prev,
  //        // printaddress: `${prev.companyname2 || ""} ${prev.address1 || ""} ${prev.country || ""}`

  //         printaddress: [
  //        prev.companyname2,
  //        prev.address1,
  //        prev.address2,
  //        prev.address3,
  //       `${prev.city || ""} ${prev.state || ""} ${prev.postalcode || ""} ${prev.province || ""}
  //        ${prev.country || ""} ${"Tel:" + prev.officetel || ""} ${prev.fax || ""} ${prev.email || ""} ${"EORI #: "+prev.eorinumber || ""}`
  //      ].filter(Boolean).join("\n")
  //     }));
  //  };

  const RefreshPrintAddress = () => {

    setFormData((prev) => {
      let addressLines = [
        prev.companyname2 || "",
        prev.address1 || "",
        prev.address2 || "",
        prev.address3 || "",
        `${prev.city || ""} ${prev.state || ""} ${prev.postalcode || ""} ${prev.province || ""} ${prev.country || ""}`.trim(),
        // Contact line (Tel and Fax)
        (() => {
          let contactLine = "";
          if (prev.officetel?.trim())
            contactLine += "Tel: " + prev.officetel.trim();
          if (prev.fax?.trim())
            contactLine += contactLine
              ? " Fax: " + prev.fax.trim()
              : "Fax: " + prev.fax.trim();
          return contactLine;
        })(),
        prev.email || "",
      ].filter(Boolean);

      // Append EORI if present
      if (prev.eorinumber?.trim()) {
        let lastIndex = addressLines.length - 1;
        addressLines[lastIndex] += " EORI #: " + prev.eorinumber.trim();
      }

      return {
        ...prev,
        printaddress: addressLines.join("\n"),
        printaddressaccount: addressLines.join("\n"),
      };
    });
  };

  // ----------------------------------------SAVE DOCUMENT START ---------------------------------------

  const [DocumentFormData, setDocumentFormData] = useState({
    ADDRESSID: formData.addressId || 0,
    specialnotesimport: formData.specialnotesimport || "",
    specialnotesexport: formData.specialnotesexport || "",
  });

  const handleDocumentInputChange = (e) => {
    const { name, value } = e.target;
    setDocumentFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (activeTab === "documentation") {
      const data = dispatch(getAddressByID(bookingData)).then((data) => {
        setDocumentFormData({
          ADDRESSID: bookingData || 0,
          specialnotesexport: data._Company.specialnotesexport || "",
          specialnotesimport: data._Company.specialnotesimport || "",
        });
      });
    }
  }, [activeTab, dispatch, bookingData]);

  const handleDocSaveOrUpdate = async () => {
    try {
      if (DocumentFormData.ADDRESSID > 0) {
        // UPDATE
        dispatch(callLoader(1));
        await DocUpdatebyAddressbook(DocumentFormData);
        dispatch(
          showToast(
            "Updated Address book Document successfully",
            "success",
            true,
          ),
        );
        // 2️⃣ Reset specialnotesexport and specialnotesimport in state
        // setFormData((prev) => ({
        //   ...prev, // keep all other fields unchanged
        //   specialnotesexport: "",
        //   specialnotesimport: "",
        // }));
      }
    } catch (error) {
      dispatch(showToast("Something went wrong", "error"));
    } finally {
      dispatch(callLoader(0));
    }
  };

  // ----------------------------------------SAVE DOCUMENT END ---------------------------------------

  // ----------------------------------------SAVE COMPLIANCETAB START ---------------------------------------

  const [complianceData, setComplianceData] = useState({
    ...initialComplianceData,
    custID: formData.companyID || 0,
  });

  useEffect(() => {
    if (activeTab === "compliance" && formData.companyID) {
      dispatch(GetComplianceCertificationByID(formData.companyID))
        .then((data) => {
          // Make sure data is not null or undefined
          if (data) {
            const complianceData_ = setComplianceData_(data);
            setComplianceData({ ...complianceData_ });
          }
        })
        .catch((err) => {
          console.error("Error fetching compliance data:", err);
        });
    }
  }, [activeTab, dispatch, bookingData]);

  const CompliancehandleSubmit = async () => {
    dispatch(callLoader(1));
    try {
      complianceData.custID = formData.companyID;
      await InsertComplianceCertification(complianceData);
      dispatch(
        showToast("Compliance data submitted successfully!", "success", true),
      );

      // ✅ RESET FORM
      // setComplianceData(emptyComplianceData);
    } catch (error) {
      console.error(error);

      dispatch(showToast("Something went wrong", "error"));
    } finally {
      dispatch(callLoader(0));
    }
  };

  const CompliancehandleChange = (key, value) => {
    setComplianceData((prev) => ({ ...prev, [key]: value }));
  };

  // ----------------------------------------SAVE COMPLIANCETAB END ---------------------------------------

  // ----------------------------------------SAVE Accounting Start ---------------------------------------

  // ----------------------------------------SAVE Accounting Start ---------------------------------------

  const _GetCompanyAddressAdditionalDetails = async (mode) => {
    try {
      dispatch(callLoader(1));
      const resultData = await dispatch(
        GetCompanyAddressAdditionalDetails(formData?.addressId, mode),
      );
      console.log("address data:", resultData);

      setModeConfigData((pre) => ({
        ...pre,
        [mode]: {
          ...initialModeData,
          ...resultData,
          addressId: formData?.addressId,
        },
      }));
    } catch (error) {
      setModeConfigData((pre) => ({ ...pre, [mode]: { ...initialModeData } }));
    } finally {
      dispatch(callLoader(0));
    }
  };

  useEffect(() => {
    const isIncluded = Object.keys(modeConfigData).some((key) =>
      key.includes(activeTab),
    );

    if (isIncluded) {
      _GetCompanyAddressAdditionalDetails(activeTab);
    }
  }, [activeTab]);

  const handleSaveModeConfig = async (modeId) => {
    const authUser = JSON.parse(localStorage.getItem("authUser"))?.[0];

    const payload = modeConfigData?.[modeId];
    payload.modeType = modeId;
    payload.addressId = formData?.addressId;
    payload.companyId = formData?.companyID;
    payload.createdBy = authUser?.username || "System";
    payload.isActive = true;

    try {
      dispatch(callLoader(1));
      if (bookingData != 0 && bookingData != null) {
        const updateDetails =
          await UpdateCompanyAddressAdditionalDetails(payload);
        if (
          updateDetails?.statuscode === 200 ||
          updateDetails?.statuscode === 201
        ) {
          //alert("Update successfully");

          dispatch(showToast("Record Update successfully", "success", true));
        }
      }
      // onBack();
    } catch (error) {
      dispatch(showToast("Something went wrong. Please try again.", "error"));
    } finally {
      dispatch(callLoader(0));
    }
    // dispatch(showToast(`${modeId.replace('-', ' ').toUpperCase()} configuration saved`, "success", true));
  };


  //-----------------------------------------Add Carrier Contract Start----------------------------------

  const [carrierList, setCarrierList] = useState([]);

  const handleAddCarrier = () => {

    const value = formData.carriercontract?.trim();

    if (!value) return;

    // duplicate (optional)
    if (carrierList.includes(value)) return;

    setCarrierList((prev) => [...prev, value]);

    // clear input
    setFormData((prev) => ({
      ...prev,
      carriercontract: ""
    }));
  };


  const handleDeleteCarrier = (index) => {
    setCarrierList((prev) => prev.filter((_, i) => i !== index));
  };


  //-----------------------------------------Add Carrier Contract End----------------------------------


  //----------------------------------------- handle check duplicate button start----------------------------


  const [duplicateCompanies, setDuplicateCompanies] = useState([]);
  const [loadingDuplicate, setLoadingDuplicate] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  const handleCheckDuplicate = async () => {


    if (!formData.companyname?.trim()) return;

    try {
      setLoadingDuplicate(true);
      dispatch(callLoader(1));
      const data = await dispatch(
        getCheckDuplicateCompanyist({
          companyName: formData.companyname,
          masterCompanyId: formData.mastercompanyid
        }));
      setDuplicateCompanies(data);
      setShowDropdown(true);

    } catch (err) {
      console.error(err.message);
    } finally {
      setLoadingDuplicate(false);
      dispatch(callLoader(0));
    }
  };

  //-----------------------------------------handle check duplicate button End------------

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="p-6 space-y-6 pb-12"
    >
      {/* Header */}
      <div className="bg-gradient-to-br from-teal-500 via-cyan-600 to-blue-700 rounded-lg shadow-lg p-4 relative">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-40 h-40 bg-white rounded-full -translate-y-1/2 translate-x-1/2" />
        </div>

        <div className="relative flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="bg-white/20 backdrop-blur-sm p-2 rounded-lg">
              <Building2 className="w-5 h-5 text-white" />
            </div>
            <div>
              <div className="flex items-center gap-2 text-teal-100 text-xs mb-0.5">
                <span>Address Book</span>
                <span>/</span>
                <span>
                  {bookingData ? `Editing Address` : "Create a new address"}
                </span>
              </div>
              <h1 className="text-lg font-bold text-white">Company Details</h1>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-1.5">
            <button className="hidden px-3 py-1.5 bg-amber-500 hover:bg-amber-600 text-white rounded-lg font-medium transition-all shadow-md flex items-center gap-1.5 text-xs">
              <AlertCircle className="w-3.5 h-3.5" /> Check DPL
            </button>
            <button className="hidden px-3 py-1.5 bg-purple-500 hover:bg-purple-600 text-white rounded-lg font-medium transition-all shadow-md flex items-center gap-1.5 text-xs">
              <CheckCircle2 className="w-3.5 h-3.5" /> Check Duplicate
            </button>
            <CelebrationButton
              onClick={() => handleSubmit()}
              label={"Save"}
              className="px-3 py-1.5 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg font-medium transition-all shadow-md flex items-center gap-1.5 text-xs"
              icon={<Save className="w-3.5 h-3.5" />}
              isSuccess={isAnimate}
            />

            <button
              onClick={() => onBack()}
              className="px-3 py-1.5 bg-red-500/80 hover:bg-red-500 text-white rounded-lg font-medium transition-all flex items-center gap-1.5 text-xs"
            >
              <X className="w-3.5 h-3.5" /> Close
            </button>
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-slate-200 dark:border-slate-800 p-1.5">
        <div className="flex flex-wrap gap-1">
          {tabs.map((tab) => {
            const isDisabled = !isEditMode && !tab.alwaysEnabled;
            return (
              <button
                key={tab.id}
                disabled={isDisabled}
                onClick={() => !isDisabled && setActiveTab(tab.id)}
                className={`px-3 py-2 rounded-md text-xs font-medium transition-all flex items-center gap-1.5 ${activeTab === tab.id
                  ? "bg-teal-600 text-white shadow-sm"
                  : "text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800"
                  }
                                ${isDisabled
                    ? "opacity-50 cursor-not-allowed"
                    : "hover:bg-slate-100 dark:hover:bg-slate-800"
                  }`}
              >
                <tab.icon className="w-3.5 h-3.5" />
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      {activeTab === "company" && (
        <>
          <div className="space-y-3">
            {/* Entity Type */}
            <div className="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden">
              <SectionHeader
                icon={Users}
                title="Entity Type"
                color="bg-indigo-600"
                section="s1"
                expandedSections={expandedSections}
                toggleSection={toggleSection}
              />
              {expandedSections.s1 && (
                <div className="p-3">
                  <div className="flex flex-wrap gap-2">
                    {(entityType || []).map((entity) => (
                      <label
                        key={entity.name}
                        className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium cursor-pointer transition-all duration-200 select-none ${!!formData?.[entity.name]
                          ? "bg-blue-600 text-white shadow-sm hover:bg-blue-700"
                          : "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400 hover:bg-slate-200 dark:hover:bg-slate-700 border border-slate-200 dark:border-slate-700"
                          }`}
                      >
                        <Input
                          type="checkbox"
                          className="sr-only"
                          value={formData?.[entity.name]}
                          checked={!!formData?.[entity.name]}
                          onChange={handleInputChange}
                          name={entity.name}
                        />
                        {!!formData?.[entity.name] && (
                          <Check className="w-3 h-3" />
                        )}
                        {entity.label}
                      </label>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <ModesOfTransportation
              expandedSections={expandedSections}
              toggleSection={toggleSection}
              formData={formData}
              handleInputChange={handleInputChange}
            />

            <CustomerDetailsSection
              expandedSections={expandedSections}
              onToggle={toggleSection}
              formData={formData}
              handleInputChange={handleInputChange}
              errors={errors}
              inputClass={inputClass}
              salesOptions={salesOptions}
              setFormData={setFormData}
              handleDateChange={handleDateChange}
              handleDateError={handleDateError}
              carrierList={carrierList}
              handleAddCarrier={handleAddCarrier}
              handleDeleteCarrier={handleDeleteCarrier}
              handleCheckDuplicate={handleCheckDuplicate}
              duplicateCompanies={duplicateCompanies}
              loadingDuplicate={loadingDuplicate}
              showDropdown={showDropdown}
              setShowDropdown={setShowDropdown}

            />

            {/* Address Details */}

            {bookingData && (
              <div className="flex justify-end space-x-2">
                <button
                  onClick={ResetAddressDetail}
                  type="button"
                  className="px-4 py-2 text-sm bg-[#0072FF] hover:bg-[#0062DD] text-white rounded-lg font-medium transition-all flex items-center space-x-1"
                >
                  <span>+ Add New Address</span>
                </button>
              </div>
            )}
            <AddressDetailsSection
              expandedSections={expandedSections}
              onToggle={toggleSection}
              formData={formData}
              handleInputChange={handleInputChange}
              errors={errors}
              inputClass={inputClass}
              countryList={countryList}
              cpPositionList={cpPositionList}
              RefreshPrintAddress={RefreshPrintAddress}
              bookingData={bookingData}
              handleSubmitAddress={handleSubmitAddress}
            />

            {/* Link To Entities */}
            {/* <div className="bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800"> */}
            <div
              className={`bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800 ${showBox ? "" : "hidden"
                }`}
            >
              <div
                className="flex items-center justify-between p-4 cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800/50"
                onClick={() => toggleSection("s4")}
              >
                <h2 className="text-sm font-semibold text-slate-900 dark:text-white">
                  Link To Entities
                </h2>
                {expandedSections.s4 ? (
                  <ChevronUp className="w-4 h-4 text-slate-600 dark:text-slate-400" />
                ) : (
                  <ChevronDown className="w-4 h-4 text-slate-600 dark:text-slate-400" />
                )}
              </div>
              {expandedSections.s4 && (
                <div className="p-4 border-t border-slate-200 dark:border-slate-800">
                  <div className="grid grid-cols-2 gap-6 items-start">
                    <div className="grid grid-cols-1 gap-4">
                      <div>
                        <MultiSearchAdd
                          label="Shipper"
                          valueKey="shipper"
                          searchAPI="v1/AutoSuggestion/GetCustomerSuggestion?Prefix="
                          formData={formData}
                          setFormData={setFormData}
                        />
                      </div>
                      <div>
                        <MultiSearchAdd
                          label="Trucker"
                          valueKey="trucker"
                          searchAPI="v1/AutoSuggestion/GetCustomerSuggestion?Prefix="
                          formData={formData}
                          setFormData={setFormData}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-1 gap-4">
                      <div>
                        <MultiSearchAdd
                          label="Consignee"
                          valueKey="consignee"
                          searchAPI="v1/AutoSuggestion/GetCustomerSuggestion?Prefix="
                          formData={formData}
                          setFormData={setFormData}
                        />
                      </div>
                      <div>
                        <MultiSearchAdd
                          label="Carrier"
                          valueKey="carrier"
                          searchAPI="v1/AutoSuggestion/GetCarrierSuggestion?Prefix="
                          formData={formData}
                          setFormData={setFormData}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Address List  */}
            <AddressListSection
              expandedSections={expandedSections}
              Addresses={Addresses || []}
              handleAddressSelect={handleAddressSelect}
              handleDelete={handleDelete}
            />
          </div>
        </>
      )}

      {/* Generic placeholder for truly undefined tabs (should rarely be needed) */}
      {activeTab !== "company" &&
        activeTab !== "documentation" &&
        activeTab !== "compliance" &&
        activeTab !== "accounting" &&
        !modeTabs.some((modeTab) => modeTab.id === activeTab) && (
          <div className="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-slate-200 dark:border-slate-800 p-12 text-center">
            <div className="w-16 h-16 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center mx-auto mb-4">
              <FileText className="w-8 h-8 text-slate-400" />
            </div>
            <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">
              {tabs.find((t) => t.id === activeTab)?.label}
            </h3>
            <p className="text-slate-500 dark:text-slate-400">
              This section is under development
            </p>
          </div>
        )}

      {activeTab === "documentation" && (
        <PccDocumentationSection
          DocumentFormData={DocumentFormData}
          handleDocumentInputChange={handleDocumentInputChange}
          handleSave={handleDocSaveOrUpdate}
          isAnimate={isAnimate}
          inputClass={inputClass}
        />
      )}

      {/* Compliance/Certification Tab */}

      {activeTab === "compliance" && (
        <>
          <ComplianceCertificationSection
            complianceData={complianceData}
            CompliancehandleChange={CompliancehandleChange}
            CompliancehandleSubmit={CompliancehandleSubmit}
            isAnimate={isAnimate}
          />
        </>
      )}

      {/* End Compliance */}

      {/* Accounting Tab */}

      {activeTab === "accounting" && (
        <AddressBookAccount
          bookingData={bookingData}
          standardTermsList={standardTermsList}
          activeTab={activeTab}
          onToggle={toggleSection}
          expandedSections={expandedSections}
        />
      )}

      {/* End Accounting */}

      {/* Mode-Specific Configuration Tabs */}
      {modeTabs.map(
        (modeTab) =>
          activeTab === modeTab.id && (
            <ModeConfigTab
              key={modeTab.id}
              modeId={modeTab.id}
              modeLabel={modeTab.label}
              ModeIcon={modeTab.icon}
              modeColor={
                modeTab.id.includes("OCEAN")
                  ? "from-blue-500 to-cyan-600"
                  : modeTab.id.includes("AIR")
                    ? "from-purple-500 to-violet-600"
                    : modeTab.id.includes("DOMESTIC")
                      ? "from-amber-500 to-orange-600"
                      : modeTab.id.includes("WAREHOUSING")
                        ? "from-emerald-500 to-green-600"
                        : "from-rose-500 to-pink-600"
              }
              modeData={modeConfigData?.[modeTab.id] || {}}
              onModeDataChange={handleModeDataChange}
              isAnimate={isAnimate}
              onSave={() => handleSaveModeConfig(modeTab.id)}
            />
          ),
      )}

      {/* End Mode-Specific Tabs */}

      {activeTab === "company" && (
        <>
          {/* Sticky Bottom Actions */}
          <div className="sticky bottom-0 bg-white/80 dark:bg-slate-900/80 backdrop-blur-lg rounded-lg shadow-lg border border-slate-200 dark:border-slate-800 p-4">
            <div className="flex items-center justify-between">
              <div className="text-sm text-slate-500 dark:text-slate-400">
                <span className="text-red-500">*</span> Required fields must be
                filled
              </div>
              <div className="flex items-center gap-3">
                <button
                  onClick={() => onBack()}
                  className="px-6 py-2.5 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 rounded-lg font-medium transition-all flex items-center gap-2"
                >
                  <X className="w-4 h-4" /> Cancel
                </button>
                <CelebrationButton
                  onClick={() => handleSubmit()}
                  label={"Save Company"}
                  className="px-6 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg font-medium transition-all shadow-lg hover:shadow-xl flex items-center gap-2"
                  icon={<Save className="w-4 h-4" />}
                  isSuccess={isAnimate}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </motion.div>
  );
};

export default AddressForm;
